export const PREVIOUS = 'pdp.gallery.prev';
export const NEXT = 'pdp.gallery.next';
